import { useEffect, useMemo, useState } from "react";
import { getUserInfo } from "../../../api";
import { UserInfo } from "../../../types";

const storeKey = "user-open-id";

const useOpenId = () => {
  const [userInfo, setUserInfo] = useState<UserInfo | null>(null);
  const openId = useMemo(() => {
    if (!userInfo?.is_login) {
      const cachedOpenId = localStorage.getItem(storeKey);
      if (cachedOpenId) return cachedOpenId;
    }
    return userInfo?.openid;
  }, [userInfo]);

  useEffect(() => {
    getUserInfo().then((userInfo) => {
      if (!userInfo.is_login) {
        const cachedOpenId = localStorage.getItem(storeKey);
        if (!cachedOpenId) {
          localStorage.setItem(storeKey, userInfo.openid);
        }
      }
      setUserInfo(userInfo);
    });
  }, []);

  return openId;
};

export default useOpenId;
